import { userConstants } from '../_constants';
import { LOCATION_CHANGE } from "react-router-redux";
import {newLoanStepperService, userService, workflowService,} from "../_services";

const userInitialState = {
    steps: [],
    currentStep: '',
    loading: false,
    items: [],
    error: '',
    language: userService.getUserLanguage().toUpperCase(),
    disclosure: {
        version: 2,
        englishText: 'For the initial purposes of pre-qualifying you for a loan, we will use credit information from one or more Credit Reporting Agencies. This information is pulled using a "soft" credit inquiry, which does not impact your credit score. If you are approved for and accept the loan, we will obtain a complete Consumer Credit Report from one or more Credit Reporting Agencies; this request for a credit report will result in a "hard" credit inquiry and may impact your credit score. In doing so, we may use your social security number which you provide, your address and other information you give us to help assure that we access the correct information for the Credit Reporting Agency.',
        spanishText: 'El proceso inicial de precalificaci�n para un pr�stamo, requiere informaci�n crediticia de una o m�s agencias de informes crediticios. Esta informaci�n se obtiene mediante una consulta crediticia �suave�, que no afecta su puntaje crediticio. Si se la solicitud de pr�stamo se aprueba el pr�stamo y usted lo acepta, obtendremos un informe de cr�dito del consumidor completo de una o m�s agencias de informes de cr�dito; esta solicitud de un informe crediticio resultar� en una investigaci�n crediticia �dura� y puede afectar su puntaje crediticio. Al hacerlo, podemos utilizar su n�mero de seguro social que usted nos haya proporcionado, su direcci�n y otra informaci�n que nos brinde para ayudar a garantizar que accedamos a la informaci�n correcta de la Agencia de informes crediticios.',
        softHit: true,
        usingDefault: true,
        isLoading: false
    }
}

export function users(state = userInitialState, action) {
  switch (action.type) {
    case userConstants.GETALL_REQUEST:
      return {
        loading: true
      };
    case userConstants.GETALL_SUCCESS:
      return {
        items: action.users
      };
    case userConstants.GETALL_FAILURE:
      return { 
        error: action.error
      };
    case userConstants.DELETE_REQUEST:
      // add 'deleting:true' property to user being deleted
      return {
        ...state,
        items: state.items.map(user =>
          user.id === action.id
            ? { ...user, deleting: true }
            : user
        )
      };
    
    case userConstants.DELETE_SUCCESS:
      // remove deleted user from state
      return {
        items: state.items.filter(user => user.id !== action.id)
      };
    case userConstants.DELETE_FAILURE:
      // remove 'deleting:true' property and add 'deleteError:[error]' property to user 
      return {
        ...state,
        items: state.items.map(user => {
          if (user.id === action.id) {
            // make copy of user without 'deleting:true' property
            const { deleting, ...userCopy } = user;
            // return copy of user with 'deleteError:[error]' property
            return { ...userCopy, deleteError: action.error };
          }

          return user;
        })
      };
    case userConstants.LOGOUT:
      return {...state};

    case LOCATION_CHANGE:
      // any time we need state change logic on route change (LOCATION CHANGE), pass it here
      let storageWorkFlowData = {};
      let steps = [];
      let stepperSteps = [];
      let currentStep = '';
      let workflowData = workflowService.getCurrentWorkflowStepData();

      // back button bug solution.
      // update the current step to the step containing the url found from location change
      if(workflowData) {
        // action.payload.pathname contains the 'next' path the user has navigated to
        // get the list of steps contained in the current workflow
        steps = workflowService.getWorkflowById(workflowData.workflowId);
        stepperSteps = newLoanStepperService(workflowData.workflowId); // current work flow

        // currentStep = stepId, currentStepperStep = <- that.
        storageWorkFlowData = JSON.parse(sessionStorage.getItem("workflowData")); // workflow state in storage

        let newNavigatedStep = steps.workflow.find(x => x.path === action.payload.pathname); //find the step the user is on based on url

        // {stepId: 1, stepperStepId: 1, path: '/PersonalInfo', isLastStep: false}
        // if a step is detected then go ahead update the workflow and stepper
        if(newNavigatedStep) {
          // if the newNavigatedStep has values, update the session storage workflowData object to account for the changes
          currentStep = newNavigatedStep.stepperStepId;
          Object.assign(storageWorkFlowData, {currentStep: newNavigatedStep.stepId, currentStepperStep: newNavigatedStep.stepperStepId });
          sessionStorage.setItem('workflowData', JSON.stringify(storageWorkFlowData));
        }
      }
      return {
        ...state,
        steps: stepperSteps,
        currentStep: currentStep
      }
    case userConstants.SET_LANGUAGE:
          let userLanguage = sessionStorage.getItem("lang");
          let newStepperSteps = [];
          let wfData = workflowService.getCurrentWorkflowStepData();
          if (wfData) {
              newStepperSteps = newLoanStepperService(wfData.workflowId);
          }
          return {
              ...state,
              language: userLanguage,
              steps: newStepperSteps,
          }
      case userConstants.GET_DISCLOSURES:
          let disclosure = state.disclosure;
          if (disclosure) {
            disclosure.isLoading = true;
          }
          return {
              ...state,
              disclosure
          }
      case userConstants.SET_DISCLOSURES:
          return {
              ...state,
              disclosure: action.disclosure
          }
    case userConstants.USERS_REDIRECT_TO_REFINANCE_LOAN_REQUEST:
            return {
                ...state,                  
                redirectToRefinance : true
            };      
    case userConstants.USERS_REDIRECT_TO_REFINANCE_LOAN_SUCCESS:
            return {
                ...state,                  
                redirectToRefinance : false,
                loginHash: null
            }; 
    case userConstants.LOGIN_WITH_HASH:
              return {
                  ...state,
                  loginHash: action.loginHash
              };            
    default:
      return {...state}
  }
}